import React, { useEffect, useMemo } from 'react';
import { Control, useWatch } from 'react-hook-form';
import { IconButton, Tooltip } from '@mui/material';
import { Icon } from '@iconify/react';
import { AsyncSelect, ControlledTextField } from '../../../../../components/forms';
import { useLEPEmisorLimiteTipos, useLEPEmisorTipos, useLEPTitulos } from "../hooks/useLEPCache";
import { useLoadOptions } from "../../../../../hooks/useLoadOptions";
import { OperacionLEPEmisorFields, OperacionLEPFields, OperacionLEPTituloFields } from "../types/fields";
import { EntityWithIdAndDescriptionFields } from "src/lib/itaptec/http_client/src";
import { ITableColumn, TableList } from "../../../../../components/table";

type FieldArrayItem = { id: string };

interface OperacionLEPLimitesNuevosTablaProps {
  fields: FieldArrayItem[];
  control: Control<any>;
  remove: (index?: number | number[]) => void;
  codSistema: number;
}

export const OperacionLEPLimitesNuevosTabla = ({ fields, control, remove, codSistema }: OperacionLEPLimitesNuevosTablaProps) => {
  const emisoresHooks = useLEPEmisorTipos(codSistema)

  const loadEmisores = useLoadOptions({
    data: emisoresHooks.emisorTipos,
    loading: emisoresHooks.isLoading,
    isError: emisoresHooks.isError,
    error: emisoresHooks.error
  });


  const columnas: ITableColumn[] = [
    {
      label: 'Razón Social',
      onRenderCell: (field: FieldArrayItem) => {
        const index = fields.findIndex(f => f.id === field.id);

        return (
          <ControlledTextField
            name={`${OperacionLEPFields.Emisores}.${index}.${OperacionLEPEmisorFields.RazonSocial}`}
            control={control}
            label='Emisor'
            fullWidth
          />
        );
      }
    },
    {
      label: 'Tipo Emisor',
      onRenderCell: (field: FieldArrayItem) => {
        const index = fields.findIndex(f => f.id === field.id);

        return (
          <AsyncSelect
            loadOptions={loadEmisores}
            selectNotNulleable
            valueField={EntityWithIdAndDescriptionFields.Id}
            name={`${OperacionLEPFields.Emisores}.${index}.${OperacionLEPEmisorFields.CodOperacionLEPEmisorTipo}`}
            control={control}
            label='Tipo Emisor'
            fullWidth
          />
        );
      }
    },
    {
      label: 'Acciones',
      onRenderCell: (field: FieldArrayItem) => {
        const index = fields.findIndex(f => f.id === field.id);

        return (
          <Tooltip title='Eliminar'>
            <IconButton  size='small' onClick={() => remove(index)}>
              <Icon icon='tabler:trash' color={'red'} />
            </IconButton>
          </Tooltip>
        );
      }
    }
  ];

  if (fields.length === 0) {
    return null;
  }

  return (
    <TableList
      entityList={fields}
      columns={columnas}
      isLoading={emisoresHooks?.isLoading}
      error={emisoresHooks?.isError}
    />
  );
};